import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const ButtonWrapper = styled.div`
  display: flex;
`
